
import { useState } from 'react';
//import usmap from './usmap';
//import mapdata from './mapdata';
import './App.css';
import Icon from './components/Icon';
import { Gallery } from './Gallery/gallery';
import { Map } from './Map/map';
import { RaceList } from './RaceList/raceList';

function App() {
  const [tab, setTab] = useState("list")
  const [showNav, setShowNav] = useState(true);
  const [currentState, setCurrentState] = useState(null);

  const setActiveTab = (tabName) => {
    setTab(tabName);
    //setShowNav(false);
  }

  const goToGallery = (stateName) => {
    setTab("gallery");
    setCurrentState(stateName)
  }

  return (
    <div className="App">
      
      <header className="App-header">
        <div className="App-header-title">          
          <div className="nav-menu" onClick={() => setShowNav(!showNav)}><Icon type='bars'/></div>
          <h3>Emily's 50 State Marathon Adventure!</h3>
        </div>
        <div className={`nav ${showNav ? '' : 'hidden'}`}>
              <div className={`nav-item ${tab === "gallery" ? "selected" : ""}`} onClick={() => setActiveTab("gallery")}>Gallery</div>          
              <div className={`nav-item ${tab === "map" ? "selected" : ""}`} onClick={() => setActiveTab("map")}>Map</div>
              <div className={`nav-item ${tab === "list" ? "selected" : ""}`} onClick={() => setActiveTab("list")}>Races</div>
          </div>
      </header>
      <div id="main-container">
        <div>
          {tab === "gallery" && <Gallery currentState={currentState} setCurrentState={setCurrentState} />}
          {tab === "map" && <Map />}
          {tab === "list" && <RaceList goToGallery={goToGallery} />}
        </div>
      </div>
        
    </div>
  );
}

export default App;
